import React, {
    createContext, useState, useMemo, 
   } from 'react';
   import PropTypes from 'prop-types';
   
   export const SideBarRefreshContext = createContext();
   
   const SideBarRefreshContextProvider = ({ children }) => {
    const [sideBarRefresh, setSideBarRefresh] = useState({
        agentProfileRefresh: false,
        agentMealRefresh: false,
        agentBookingRefresh: false,
        agentTripRefresh: false,
        agentAccountRefresh: false,
        agentApprovedRefresh: false,
        agentpendinRefresh: false,
        agentrejectRefresh: false,
        agentUserRefresh: false,
    });


  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    sideBarRefresh, setSideBarRefresh,
  }), [
    sideBarRefresh]);

   
     return (
       <SideBarRefreshContext.Provider value={value}>
         {children}
       </SideBarRefreshContext.Provider>
     );
   };
   
   SideBarRefreshContextProvider.propTypes = {
     children: PropTypes.node.isRequired,
   };
   
   export default SideBarRefreshContextProvider;
